import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelType } from 'models/enums/travelType';
import { RequestedItem } from 'models/requestHistory';
import ResponseScreen, { BackgroundTypes, IconTypes } from 'screens/components/ResponseScreen';

interface Props {
  show: boolean;
  travel?: RequestedItem;
  onConfirm: () => void;
}

const SolicitationReproved = ({ show, travel, onConfirm }: Props) => {
  const { t } = useStoreTranslation();

  const isHotel = travel?.type === TravelType.Hotel;
  const isAuto = travel?.type === TravelType.Vehicle;

  return (
    <ResponseScreen
      show={show}
      text={t('solicitationReproved.text')}
      subText={t(
        isHotel
          ? 'solicitationReproved.subTextHotel'
          : isAuto
          ? 'solicitationReproved.subTextAuto'
          : 'solicitationReproved.subTextFlight',
        {
          user: travel?.userName || '',
        },
      )}
      buttonText={t('solicitationReproved.buttonText')}
      background={BackgroundTypes.Cloud}
      icon={IconTypes.Airplane}
      buttonOnClick={onConfirm}
    />
  );
};

export default SolicitationReproved;
